var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 21.3535C9.56998 21.3535 8.22458 21.0839 6.96551 20.5448C5.70646 20.0057 4.60809 19.2672 3.67041 18.3296C2.73273 17.3919 1.99431 16.2942 1.45516 15.0364C0.916043 13.7786 0.646484 12.4339 0.646484 11.0022C0.646484 9.57043 0.916051 8.22503 1.45518 6.96596C1.99432 5.70691 2.73198 4.6083 3.66818 3.67011C4.60438 2.73193 5.70171 1.99116 6.96016 1.44781C8.21861 0.904479 9.5641 0.632812 10.9966 0.632812C12.4292 0.632812 13.7755 0.904121 15.0357 1.44674C16.2959 1.98935 17.3947 2.72912 18.3322 3.66604C19.2696 4.60297 20.0098 5.70115 20.5528 6.96059C21.0957 8.22004 21.3672 9.56658 21.3672 11.0002C21.3672 12.4332 21.0955 13.7792 20.5522 15.0381C20.0088 16.297 19.268 17.3948 18.3299 18.3313C17.3917 19.2678 16.2937 20.0057 15.036 20.5448C13.7782 21.0839 12.4334 21.3535 11.0017 21.3535ZM5.10336 16.9013L10.9998 11.0029V2.62739C8.67078 2.62739 6.69306 3.44012 5.06661 5.06559C3.44016 6.69104 2.62693 8.66689 2.62693 10.9931C2.62693 12.1124 2.84125 13.1792 3.26988 14.1937C3.6985 15.2082 4.30966 16.1107 5.10336 16.9013Z",
    fill: "#96A1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.d29358463c82d10a6af4953e8e3a4e54.svg";
export { ForwardRef as ReactComponent };